import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { ProgressBarModule } from 'primeng/progressbar';
import { TagModule } from 'primeng/tag';
import { PageDataPanelComponent } from '../../../shared/page-layout/page-data-panel.component';
import { PageHeroComponent } from '../../../shared/page-layout/page-hero.component';
import { PageShellComponent } from '../../../shared/page-layout/page-shell.component';
import { app_permissions } from '../../../security/app-permissions';
import { PermissionService } from '../../../security/permission.service';
import { SessionStorageService } from '../../../services/session-storage.service';
import { RentalAnalytics, RentalMigrationReadiness } from '../rental.model';
import { RentalService } from '../rental.service';

@Component({
    selector: 'app-rental-overview',
    standalone: true,
    templateUrl: './rental-overview.component.html',
    styleUrls: ['./rental-overview.component.css'],
    imports: [CommonModule, ButtonModule, ProgressBarModule, TagModule, PageShellComponent, PageHeroComponent, PageDataPanelComponent]
})
export class RentalOverviewComponent implements OnInit {
    analytics?: RentalAnalytics;
    migrationReadiness?: RentalMigrationReadiness;
    loading = false;
    readonly canManage: boolean;
    readonly canViewAnalytics: boolean;

    constructor(private rentalService: RentalService, private session: SessionStorageService, private permissions: PermissionService, private router: Router) {
        this.canManage = permissions.hasPermission(app_permissions.fleet.rental.manage);
        this.canViewAnalytics = permissions.hasPermission(app_permissions.fleet.rental.analytics.view);
    }

    ngOnInit(): void { this.load(); }

    load(): void {
        const companyId = this.companyId();
        if (!companyId) return;
        this.loading = true;
        this.rentalService.getMigrationReadiness(companyId).subscribe({ next: response => this.migrationReadiness = response.data, error: () => this.migrationReadiness = undefined });
        if (this.canViewAnalytics) {
            this.rentalService.getAnalytics(companyId).subscribe({ next: response => { this.analytics = response.data; this.loading = false; }, error: () => { this.analytics = undefined; this.loading = false; } });
        } else {
            this.loading = false;
        }
    }

    navigate(path: string): void { this.router.navigate([path]); }
    private companyId(): number { return this.session.getCompany()?.id ?? 0; }
}
